import React from "react";

/** Solid, semi-transparent style to match other PipelineCard icons (dock, preview, etc.). */
export function ThumbsUpPipelineIcon() {
  return (
    <svg
      width="55"
      height="55"
      viewBox="0 0 55 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_thumbsUpPipeline)">
        <g transform="translate(7.5, 9.5) scale(1.667)">
          <path
            d="M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2z"
            fill="white"
            fillOpacity="0.3"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_thumbsUpPipeline">
          <rect width="55" height="55" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
